module.exports = __webpack_public_path__ + "media/images/hero_images/security-3000-f97d9892ff10b06666d11a1fc8bb7c39.jpg";